import { createMarkup } from '@hub/libs/utils';
import { Icon, IconID } from '@hub/common/Icon/Icon';
import { getLocale } from '@hub/libs/constants';
import { IGUS_REWRITE } from '@hub/libs/redirect.helper';
import classNames from 'classnames';
import styles from './KoplaTeaser.module.scss';
import { useRouter } from 'next/router';
import type { Teasers } from '@hub/generated/graphql';
import { WidenUtil } from '@hub/libs/widen-utils';
import { WidenImageConfig } from '@hub/models/widen-image-config';
import { usePiwikPro } from '@piwikpro/next-piwik-pro';
import { getEventCategory, TRACKED_STANDARD_EVENT_ACTIONS } from '@hub/libs/tracking';

export interface KoplaTeaserProps {
  tools: Teasers[];
}

export const KoplaTeaser = ({ tools }: KoplaTeaserProps) => {
  const { CustomEvent } = usePiwikPro();
  const router = useRouter();
  const locale = getLocale(router);
  const filteredTools = tools?.filter(tool => tool);
  if (!filteredTools.length) {
    return null;
  }

  return (
    <>
      {filteredTools.map(tool => {
        const widenKey = tool.widen_url ? WidenUtil.extractWidenImageId(tool.widen_url) : null;
        const url = widenKey ? WidenUtil.getWidenCDNUrl(new WidenImageConfig(widenKey, 'tool-image', 105)) : null;
        return (
          <a
            key={tool.id}
            aria-label="next image"
            href={IGUS_REWRITE(tool.link ?? '', locale)}
            className={classNames('flex space-y-3', styles.koplaTeaser)}
            target="_blank"
            rel="noreferrer"
            onClick={() => {
              const eventCategory = getEventCategory(router.asPath);
              if (eventCategory) {
                CustomEvent.trackEvent(eventCategory, TRACKED_STANDARD_EVENT_ACTIONS.onlineToolsOpen, tool.label);
              }
            }}
          >
            <div className={classNames('flex mx-3 mt-3', styles.imageContainer)}>
              {url && (
                <img
                  loading="lazy"
                  className="w-full"
                  src={url}
                  alt={tool.text?.toString()}
                  title={tool.label?.toString()}
                />
              )}
            </div>
            <div className="bg-gray-50 py-8 px-8 flex-1">
              <h5>{tool.label}</h5>
              <span className="mt-4" dangerouslySetInnerHTML={createMarkup(tool.text ?? '')} />
              <span className="float-right">
                <Icon primary={false} id={IconID.THREE_ARROWS} size={6} />
              </span>
            </div>
          </a>
        );
      })}
    </>
  );
};
